export default "__VITE_ASSET__nxxtyyEF__"